<template>
    <div class="user-intro" v-if="profile">
        <div class="title"><i class="material-icons">article</i>자기소개</div>
        <div class="text">{{ userIntro }}</div>
    </div>
</template>
<script>
export default {
    name: 'UserIntro',
    props: ['profile'],
    computed: {
        userIntro() {
            return (this.profile.intro || '').trim() || '-'
        },
    },
}
</script>
<style scoped lang="scss">
.title {
    display: flex;
    align-items: center;
    .material-icons {
        color: black;
    }
}
</style>
